import { Grid, Typography } from "@material-ui/core";
import React from "react";
import DateHelper from "../../../utilities/DateHelper";
import { ApplicationUser } from "../../../entities/ApplicationUser";

interface TermsAndConditionsProps {
    user?: ApplicationUser;
    isMonthly: boolean;
    costOfPlan: string;
}

export function TermsAndConditions(props:TermsAndConditionsProps){
    const { user, isMonthly, costOfPlan } = props;
    return (
        <Grid item xs={12}>
            <Typography variant="body2" style={{ opacity: .88 }}>
                Click 
                <span>
                    { user && isMonthly && " 'Start Now' " }
                    { !user && isMonthly && " 'Create My Account' "}
                    { !isMonthly && " 'Start My Free Trial' " }
                </span>
                to agree to the&nbsp;
                <a style={{color: "rgba(0, 0, 0, 0.87)"}} href="https://www.sermoncentral.com/Content/termsandconditions" rel="noopener noreferrer" target="_blank">
                    End User License Agreement
                </a>
                &nbsp;and&nbsp;
                <a style={{color: "rgba(0, 0, 0, 0.87)"}} href="https://www.sermoncentral.com/Content/privacy-policy" rel="noopener noreferrer" target="_blank">
                    Privacy Policy.
                </a>
                &nbsp;{isMonthly && "Each month, "}your subscription will automatically bill 
                { isMonthly && <span> at <strong>{costOfPlan}</strong></span>}
                { !isMonthly && <span> on <strong>{DateHelper.renewalDate(true)} for {costOfPlan.substring(0,4)} per year</strong></span>}
                , unless you cancel. {!isMonthly && "You will be emailed a reminder 7 days before your trial ends. "}
                Your info is private and all sermon data is protected.  You won't lose it, even if you cancel.
            </Typography>
        </Grid> 
    )
}